<app-route-name-bar [routeName]="routeName"></app-route-name-bar>
<div class="account-container">
  <router-outlet></router-outlet>
</div>
